module.exports = __webpack_public_path__ + "static/media/full.d1f3972f.png";